
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "CreateDriverScheduleSettingAndEventsResult": [
      "CreateDriverScheduleSettingAndEventsSuccess",
      "CreateDriverScheduleSettingAndEventsFailure"
    ],
    "DriverCloseoutRouteV2Result": [
      "DriverCloseoutRouteV2Success",
      "DriverCloseoutRouteV2Failure"
    ],
    "FarmAffiliate": [
      "ExternalOperator",
      "MoovsNetworkOperator",
      "GriddnetOperator",
      "MoovsAiOperator"
    ],
    "MetadataUnion": [
      "TripChangeMetadata"
    ],
    "Node": [
      "Billing",
      "CancellationPolicy",
      "Comment",
      "Company",
      "Contact",
      "Contract",
      "Driver",
      "DriverAvailability",
      "EmailLog",
      "ExternalOperator",
      "Garage",
      "GriddnetOperator",
      "InsurancePolicy",
      "Invoice",
      "MoovsAiOperator",
      "MoovsNetworkOperator",
      "Operator",
      "OperatorRoute",
      "Payment",
      "PaymentMethod",
      "PaymentRefund",
      "Request",
      "Route",
      "ShuttleRoute",
      "Stop",
      "SubPayment",
      "SubRefund",
      "TeamMember",
      "TrackedFlight",
      "Transaction",
      "Trip",
      "User",
      "UserAccessPermission",
      "Vehicle",
      "VehicleCategory",
      "VehicleChildSeat",
      "VehicleFeature",
      "VehiclePhoto"
    ]
  }
};
      export default result;
    